import cn from "classnames";
import { RefObject } from "react";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import remarkGfm from "remark-gfm";
import { ScrollToAnchor } from "src/components";
import { useGravityDevice } from "src/hooks";
import { RoutePathKeys } from "src/pages/KnowledgeBasePage/constants";

import { MarkdownComponents } from "./components";
import { useScrollSpy } from "./hooks/useScrollSpy";
import styles from "./KnowledgeMarkdown.module.scss";
import "github-markdown-css/github-markdown.css";

interface KnowledgeMarkdownProps {
  content: string;
  basePath: string;
  onActiveChange: (id: string | null) => void;
  framerRef: RefObject<HTMLDivElement>;
  route: RoutePathKeys;
}

export const KnowledgeMarkdown = ({
  content,
  basePath,
  onActiveChange,
  framerRef,
  route,
}: KnowledgeMarkdownProps) => {
  const device = useGravityDevice();
  const isMobile = !device.isDesktop;
  const rootEl = isMobile || route === "base" ? null : framerRef.current;

  const handleActiveChange = (id: string) => {
    onActiveChange(id);
    if (typeof window !== "undefined") {
      history.replaceState(null, "", `#${id}`);
    }
  };

  const activeId = useScrollSpy(
    ["h1[id]", "h2[id]", "h3[id]"],
    rootEl,
    handleActiveChange,
  );

  return (
    <>
      <ScrollToAnchor />
      <div
        data-active-id={activeId}
        className={cn(styles.markdownBody, "markdown-body")}
      >
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeHighlight]}
          components={MarkdownComponents(basePath)}
        >
          {content}
        </ReactMarkdown>
      </div>
    </>
  );
};
